import { useEffect, useState } from "react";
import config, { ZERO_ADDRESS } from "../config/config";
import {
  getCurrentRoundId as getLotteryCurrentRoundId,
  getRound as getLotteryRound,
} from "../helper/contractFunctions/MafiaLotteryHall";

export type LotteryHallSidebarInfo = {
  roundId: number;
  endTime: number;
  entriesCash: number;
};

const DEFAULT_INFO: LotteryHallSidebarInfo = {
  roundId: 0,
  endTime: 0,
  entriesCash: 0,
};

export default function useLotteryHallSidebar(pollMs = 15000) {
  const lotteryHallAddress = (config as any).lotteryHall as string | undefined;
  const isConfigured = !!lotteryHallAddress && lotteryHallAddress !== ZERO_ADDRESS;

  const [info, setInfo] = useState<LotteryHallSidebarInfo>(DEFAULT_INFO);

  useEffect(() => {
    if (!isConfigured) return;

    let cancelled = false;

    const refresh = async () => {
      try {
        const id = await getLotteryCurrentRoundId();
        const r = await getLotteryRound(id);
        if (cancelled) return;
        setInfo({
          roundId: id,
          endTime: r.endTime,
          entriesCash: r.totalEntriesCash,
        });
      } catch (e) {
        // Sidebar should be resilient.
        console.error(e);
      }
    };

    refresh();
    const interval = setInterval(refresh, pollMs);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [isConfigured, pollMs]);

  return { isConfigured, info };
}

